import React from 'react';

import {
  ScreenAllFilters,
  ScreenFilters,
  ScreenFiltersApply,
} from 'components/Filters';
import { ScreenPresets } from 'components/Presets';

import { Route } from '@gogame/screens';
import { Sentry } from '@gogame/components';
import { Screen, withScreen, createScreenRoute } from '@gogame/screens';

import { ParentCampaignDetailsRouteElement } from './components/ParentCampaignDetails';
import { ParentCampaignsDataTable } from './components/ParentCampaignsDataTable';
import AllFilters from './components/Filters/AllFilters';
import PrimaryFilters from './components/Filters/PrimaryFilters';
import {
  parentCampaignsLink,
  parentCampaignsSearchParams,
  parentCampaignDetailsLink,
} from './navigation';
import { EMPTY_FILTERS } from './schemas';
import { mapStateToPreset } from './schemas';
import screenReducer from './screenReducer';

const id = 5;
const permission = 3;

const ParentCampaigns = withScreen({
  name: 'parent-campaigns',
  searchParams: parentCampaignsSearchParams,
  reducer: screenReducer,
})(() => {
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <ScreenPresets mapStateToPreset={mapStateToPreset} />
        <ScreenFilters emptyValues={EMPTY_FILTERS}>
          <PrimaryFilters />
          <ScreenAllFilters sidePage={AllFilters} />
          <ScreenFiltersApply />
        </ScreenFilters>
        <ParentCampaignsDataTable />
      </Screen.Body>
      <Sentry.Routes>
        <Route
          path={parentCampaignDetailsLink.path}
          element={<ParentCampaignDetailsRouteElement />}
        />
      </Sentry.Routes>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'Parent Campaigns',
  link: parentCampaignsLink,
  id: id,
  permission: permission,
  screen: <ParentCampaigns />,
});
